import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function StickyMobileCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling past 600px (approx hero height)
      if (window.scrollY > 600) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const handleBuyClick = () => {
    window.open('https://pay.hotmart.com/D103645894Y?checkoutMode=10', '_blank', 'noopener,noreferrer');
  };
  return <AnimatePresence data-id="element-292">
      {isVisible && <motion.div initial={{
      y: 100
    }} animate={{
      y: 0
    }} exit={{
      y: 100
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 30
    }} className="fixed bottom-0 left-0 right-0 z-50 bg-bg-card border-t border-border-color p-4 md:hidden shadow-[0_-4px_20px_rgba(0,0,0,0.5)]" data-id="element-293">
          <div className="flex flex-col items-center space-y-2" data-id="element-294">
            <button onClick={handleBuyClick} className="w-full bg-cta-primary text-cta-text font-bold uppercase tracking-wide py-3 rounded-lg shadow-lg shadow-cta-primary/20 active:scale-95 transition-transform" data-id="element-295">
              Comprar $6.99
            </button>
            <div className="flex items-center space-x-1 text-xs text-text-secondary" data-id="element-296">
              <ShieldCheck className="w-3 h-3 text-cta-primary" data-id="element-297" />
              <span data-id="element-298">Garantía 7 días</span>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}